import * as Enums from '../../gen-src/preslayer/Enums';
import { DataDictionaryPresModel } from '../../gen-src/preslayer/PresModels';

/**
 * Contains static helper methods for converting from an underlying data pres model into the api representation.
 * Most of the code is a direct port from ApiUnderlyingDataHandler.cs
 * https://opengrok/source/xref/teams_near/workgroup/vqlweb/scriptsharp/src/UI/Api/ApiUnderlyingDataHandler.cs
 */
export class UnderlyingDataConverter {
  public static lookupValueFromDictionaryAsString(
    dataDictionary: DataDictionaryPresModel,
    dt: Enums.DataType,
    index: number,
  ): string | null {
    let result: string | null = null;

    const rawValue = UnderlyingDataConverter.lookupValueFromDictionary(dataDictionary, dt, index);
    if (rawValue !== null) {
      result = rawValue.toString();
    }

    return result;
  }

  public static lookupValueFromDictionary(
    // tslint:disable-next-line:no-any
    dataDictionary: DataDictionaryPresModel,
    dt: Enums.DataType,
    index: number,
  ): any {
    if (index < 0) {
      // per cl 280396 / bugzid 81197 negative data value index means that it is special
      dt = Enums.DataType.String;
      index = -index - 1;
    }

    return UnderlyingDataConverter.getRawValue(dataDictionary, dt, index);
  }

  /* tslint:disable-next-line:no-any */
  public static getRawValue(dataDictionary: DataDictionaryPresModel, dt: Enums.DataType, index: number): any {
    if (!dataDictionary.dataSegments) {
      return null;
    }

    for (const key of Object.keys(dataDictionary.dataSegments)) {
      const dataSegment = dataDictionary.dataSegments[key];
      for (const dataColumn of dataSegment.dataColumns) {
        if (!dataColumn || dataColumn.dataType !== dt) {
          continue;
        }

        if (index < dataColumn.dataValues.length) {
          return dataColumn.dataValues[index];
        }

        index -= dataColumn.dataValues.length;
        break;
      }
    }

    return null;
  }
}
